import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
// import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import * as coreSelectors from '../core/selectors';
import * as accountSelectors from '../account/selectors';
import * as accountActions from '../account/actions';
import * as AccountIcons from '../account/Icons';
import CallVolumeReport from './CallVolumeReport';
import * as MuiCore from '@material-ui/core';
import TableChart from '../ui/TableChart'
import { formatPhoneNumber } from '../ui/Formatters';

const styles = theme => ({
    contentBox: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    rootGrid: {
        padding: theme.spacing(1),
        overflow: 'auto',
    },
    root: {
        flexGrow: theme.spacing(1),
    }, paper: {
        borderRadius: 20,
        padding: 20,
        // marginRight: 10,
        // marginBottom: 10,
        textAlign: 'center',
    },
    table: {
        marginTop: 10,
    },
    tableHead: {
        background: theme.palette.primary.main,
        backgroundImage: "linear-gradient(160deg, #ff0096, #7f004b)",
        color: '#fff',
    },
    tableTitle: {
        color: '#fff'
    }, topLayout: {
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 1,
        width: '100%',
        height: '100%',
    },
    titleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    title: {
        ...theme.typography.h6,
        paddingLeft: 20,
        paddingRight: 20,
        fontFamily: 'Sofia-bold'
    },
    box: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: '50%',
        bottom: '70%',
        marginRight: 10,
        marginBottom: 10,
        // borderRadius: 20,
        padding: 0,
    },
    dropdown: {
        marginRight: 10,
        align: 'right'
    },
    biReportStyle: {
        height: 500,
        overflow: "auto"
    }
});

class Reports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            callVolumes: {
                id:1,
                series: [{
                    name: 'Call Volume',
                    data: []
                }, {
                    name: 'Billable Minutes',
                    data: []
                }],
                categories: []
            },
            actualAccountId: null,
            showMinimal: false,
        };
    }

    componentDidMount() {
        document.title = 'Ruby - Insights';
        var accounts = (this.props.user.userAccountRoles || [])
            .filter(role => (role.userRoleKey === 'GLOBALADMIN'));
        if (this.props.accountId !== '') {
            this.props.queryAccount();
            this.props.queryTasksByInvoice(this.props.accountId, this.props.invoiceId);
            this.props.queryCallSummaryStats(this.props.accountId, this.props.invoiceId);
            this.props.queryCallVolumes(this.props.accountId, this.props.invoiceId);
            this.props.getPhoneNumberInsights(this.props.accountId);
            this.props.queryContactInsights(this.props.accountId, this.props.invoiceId);
        }
        else if (accounts.length > 0 && this.props.accountId === '') {
            this.props.setAccountId(accounts[0].accountId);
            this.props.queryTasksByInvoice(accounts[0].accountId, this.props.invoiceId);
            this.props.queryCallSummaryStats(accounts[0].accountId, this.props.invoiceId);
            this.props.queryCallVolumes(accounts[0].accountId, this.props.invoiceId);
            this.props.getPhoneNumberInsights(accounts[0].accountId);
            this.props.queryContactInsights(accounts[0].accountId, this.props.invoiceId);
        }
    }

    componentDidUpdate(prevProps) {
        if(this.state.actualAccountId === null){
            this.setState({actualAccountId: this.props.accountId});
            this.props.queryAccount();
            this.props.queryCallSummaryStats(this.props.accountId, this.props.invoiceId);
            this.props.queryTasksByInvoice(this.props.accountId, this.props.invoiceId);
            this.props.queryCallVolumes(this.props.accountId, this.props.invoiceId);
            this.props.getPhoneNumberInsights(this.props.accountId);
            this.props.queryContactInsights(this.props.accountId, this.props.invoiceId);
        }
        // if (prevProps.accountId !== this.props.accountId) {
        //     this.props.queryAccount();
        //     this.props.queryCallSummaryStats(this.props.accountId, this.props.invoiceId);
        //     this.props.queryTasksByInvoice(this.props.accountId, this.props.invoiceId);
        //     this.props.queryCallVolumes(this.props.accountId, this.props.invoiceId);
        //     this.props.getPhoneNumberInsights(this.props.accountId);
        //     this.props.queryContactInsights(this.props.accountId, this.props.invoiceId);
        // }
        
        // if(prevProps.callVolumes && prevProps.callVolumes.id !== this.props.callVolumes.id){
        //     console.log("*** call volumes ****",this.props.callVolumes)
        //     if(this.props.callVolumes){
        //         var newCallInsights = {...this.state.callVolumes};
        //         newCallInsights.series = this.props.callVolumes.series;
        //         newCallInsights.categories= this.props.callVolumes.categories;
        //         this.setState({callVolumes:newCallInsights})
        //         console.log("***** updating new call volumes *****")
        //     }
        // }
    }

    changeInvoice = (event) => {
        this.props.queryTasksByInvoice(this.props.accountId, event.target.value);
        if(this.state.showMinimal){
            this.props.queryCombinedCallSummaryStats(this.props.accountId, event.target.value);
        } else {
            this.props.queryCallSummaryStats(this.props.accountId,  event.target.value);
        }   
        this.props.queryCallVolumes(this.props.accountId,  event.target.value, this.state.showMinimal ? 'all' : 'current');
        this.props.getPhoneNumberInsights(this.props.accountId);
        this.props.queryContactInsights(this.props.accountId,  event.target.value);
        this.props.setInvoiceId(event.target.value);
    }

    toHHMMSS = (value) => {
        value = isNaN(value) ? 0: value
        var sec_num = parseInt(Math.round(value), 10); // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);
    
        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        if(hours === "00"){
          return minutes+':'+seconds;
        }
        return hours+':'+minutes+':'+seconds;
      }

    render() {
        const { classes, phoneNumberInsights, account } = this.props;
        var distinctAccounts=[];
        var accounts = (this.props.user.userAccountRoles || [])
                        .filter((role,index,arr) => {
                        if(role.userRoleKey === 'GLOBALADMIN' && distinctAccounts.indexOf(role.accountId) === -1){
                          distinctAccounts.push(role.accountId)
                          return true;
                        }else{
                          return false;
                        }
                      });
        let insightsData = {};
        if(Array.isArray(phoneNumberInsights) && account){
            let series = [];
            let phoneNumbers = [...new Set(account?.phoneNumbers?.map((item) => item.phoneNumber))];
            let categories = [...new Set(phoneNumberInsights.map((item) => item.call_date))];
            let counts = phoneNumbers.map(phoneNumber => {
                let count = phoneNumberInsights.filter((item) => item.dnis === phoneNumber).map((item) => item.call_count).reduce((a, b) => a + b, 0);
                return { phoneNumber, count };
            });
            counts.sort((a, b) => b.count - a.count);
    
            let top6 = counts.slice(0, 6);
    
            phoneNumbers = []
            top6.forEach(item => {
                phoneNumbers.push(item.phoneNumber);
                let phoneNumber = item.phoneNumber;
                let data = categories.map((category) => phoneNumberInsights.find((item) => item.dnis === phoneNumber && item.call_date === category) ? phoneNumberInsights.find((item) => item.dnis === phoneNumber && item.call_date === category).call_count : 0);
                series.push({data: data, name: formatPhoneNumber(phoneNumber)});
            });
            // phoneNumbers.forEach(phoneNumber => {
            //     let data = categories.map((category) => phoneNumberInsights.find((item) => item.dnis === phoneNumber && item.call_date === category) ? phoneNumberInsights.find((item) => item.dnis === phoneNumber && item.call_date === category).call_count : 0);
            //     series.push({data: data, name: formatPhoneNumber(phoneNumber)});
            // })
            insightsData = {categories: categories, series: series};
        }
        return (
            <div className={classes.root}>
                <Grid container className={classes.rootGrid}>

                    <Grid item md={12} xs={12} style={{display:'flex',justifyContent:'center',alignItems:'center',padding:"16px",flexWrap:'wrap'}}>
                    <MuiCore.FormControl className={classes.formControl}>
                          <MuiCore.InputLabel id="demo-simple-select-label" style={{fontFamily: 'Sofia'}}>Account</MuiCore.InputLabel>
                        <MuiCore.Select className={classes.dropdown} style={{fontFamily: 'Sofia'}}
                            labelId="demo-simple-select-label"
                            onChange={(event) => {
                                this.setState({actualAccountId: event.target.value});
                                this.props.setInvoiceId(-1);
                                if(!String(event.target.value).includes('combined')){
                                    this.props.setAccountId(event.target.value)
                                    this.setState({showMinimal: false});
                                    if (event.target.value !== 'n') {
                                        this.props.queryAccount();
                                        this.props.queryCallSummaryStats(event.target.value, -1);
                                        this.props.queryTasksByInvoice(event.target.value, -1);
                                        this.props.queryCallVolumes(event.target.value, -1);
                                        this.props.getPhoneNumberInsights(event.target.value);
                                        this.props.queryContactInsights(event.target.value, -1);
                                    }
                                } 
                                else {
                                    this.setState({showMinimal: true});
                                    let parentAccountId = event.target.value.split(",.,")[1];
                                    this.props.setAccountId(parentAccountId);
                                    this.props.queryAccount();
                                    this.props.queryCombinedCallSummaryStats(parentAccountId, 0);
                                    this.props.queryCallVolumes(parentAccountId,  0, 'all');
                                    this.props.getPhoneNumberInsights(parentAccountId);
                                }
                            }}
                            value={this.state.actualAccountId}>

                            {accounts.map(account => (
                                <MuiCore.MenuItem key={account.accountId} value={account.accountId} style={{fontFamily: 'Sofia'}}>
                                    {account.accountNumber} {account.accountName}
                                </MuiCore.MenuItem>
                            ))}

                            {accounts.filter(account => account.showCombinedUsage === 'Y').map(account => (
                                <MuiCore.MenuItem key={'combined,.,' + account.accountId} value={'combined,.,' + account.accountId} style={{fontFamily: 'Sofia'}}>
                                    {`Combined Usage (${account.accountName})`}
                                </MuiCore.MenuItem>
                            ))}

                        </MuiCore.Select>
                        </MuiCore.FormControl>


                    </Grid>

                    <Grid item md={12} xs={12} style={{padding: 10}}>

                        {insightsData.series && account?.phoneNumbers && account?.phoneNumbers?.length > 0 &&
                            <TableChart size="31" icon={<AccountIcons.UsageBarIcon style={{color:'black'}} />} content={insightsData} heading="Phone Number Insights (last 30 days)" subTitle="Features top six Ruby Forwarding Numbers" yAxisLabel="Call Volume" format="MM/DD" />
                        }

                           


                        {/* <Paper className={classes.paper}>
                            <div style={{ display: 'flex' }}>
                                <div className={classes.titleBar}>
                                    <AccountIcons.UsageBarIcon />
                                    <div className={classes.title}>
                                        Usage Insights
                                    </div>
                                </div>
                            </div>
                            <ReactApexChart
                                options={this.props.callVolumes.options}
                                series={this.props.callVolumes.series}
                                type="bar"
                                height={350}
                            />
                        </Paper> */}
                    </Grid>
                    <Grid item xs={12} style={{display:'flex',justifyContent:'center',alignItems:'center',padding:"16px",flexWrap:'wrap'}}>
                        <MuiCore.FormControl className={classes.formControl}>
                        <MuiCore.InputLabel id="demo-simple-select-label" style={{fontFamily: 'Sofia'}}>Invoice</MuiCore.InputLabel>
                        <MuiCore.Select className={classes.dropdown}
                                    onChange={this.changeInvoice}
                                    style={{fontFamily: 'Sofia'}}
                                    value={this.props.invoiceId}>
                                    <MuiCore.MenuItem value={-1} style={{fontFamily: 'Sofia'}}>
                                        CURRENT
                                            </MuiCore.MenuItem>
                                    {this.props.account && this.props.account.invoices && this.props.account.invoices.map((item) =>
                                        <MuiCore.MenuItem value={item.invoiceId} key={item.invoiceId} style={{fontFamily: 'Sofia'}}>
                                            {item.invoiceNumber}-{new Date(item.invoiceDate).toLocaleDateString()}
                                        </MuiCore.MenuItem>
                                    )}

                            </MuiCore.Select>
                        </MuiCore.FormControl>
                    </Grid>

                    {!this.state.showMinimal && <Grid item md={12} xs={12} style={{padding: 10, border: '1px solid #CCCDD2', margin: 20}}>
                        {/* <Paper className={classes.paper}> */}
                            <div className={classes.titleBar}>
                                <div style={{ display: 'flex' }}>
                                    {/* <AccountIcons.TableReportIcon /> */}
                                    <div className={classes.title}>
                                        Activity Report
                                        </div>
                                </div>

                               
                            </div>
                            <CallVolumeReport />
                        {/* </Paper> */}
                    </Grid>}
                    <Grid item md={12} xs={12} style={{padding: 10, border: '1px solid #CCCDD2', margin: 20}}>
                        {/* <Paper className={classes.paper}> */}
                            <div className={classes.titleBar}>
                                <div style={{ display: 'flex' }}>
                                    {/* <AccountIcons.ReportIcon /> */}
                                    <div className={classes.title}>
                                        Current Call Usage
                                    </div>
                                </div>
                            </div>

                            <TableContainer>
                                <Table className={classes.table} size="small" aria-label="dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Total Calls</TableCell>
                                            <TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Billable Minutes</TableCell>
                                            <TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Average Billable Time</TableCell>
                                         
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row" style={{fontFamily: 'Sofia'}}>
                                                {this.props.callSummaryStats.totalTasks}
                                            </TableCell>
                                            <TableCell align="center" style={{fontFamily: 'Sofia'}}> {this.props.callSummaryStats.totalBillable}</TableCell>
                                            {/* <TableCell align="center">{Math.round(this.props.callSummaryStats.totalBillable/this.props.callSummaryStats.totalTasks)}</TableCell> */}
                                            {/* change to billable minutes */}
                                            <TableCell align="center" style={{fontFamily: 'Sofia'}}> {this.toHHMMSS(Math.round((this.props.callSummaryStats.totalBillable*60)/this.props.callSummaryStats.totalTasks))}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        {/* </Paper> */}
                    </Grid>
                    <Grid item md={12} xs={12} style={{padding: 10, border: '1px solid #CCCDD2', margin: 20}}>
                        {/* <Paper className={classes.paper}> */}
                            <div className={classes.titleBar}>
                                <div style={{ display: 'flex' }}>
                                    {/* <AccountIcons.AssistUsageIcon /> */}
                                    <div className={classes.title}>
                                        Current Billable Assists
                                    </div>
                                </div>
                            </div>

                            <TableContainer>
                                <Table className={classes.table} size="small" aria-label="dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Total Assists</TableCell>
                                            <TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Billable Assist Minutes</TableCell>
                                            <TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Average Billable Assist Time</TableCell>
                                         
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row" style={{fontFamily: 'Sofia'}}>
                                                {!this.props.callSummaryStats.totalAssist ? '0' : this.props.callSummaryStats.totalAssist}
                                            </TableCell>
                                            <TableCell align="center" style={{fontFamily: 'Sofia'}}> {!this.props.callSummaryStats.totalBillableAssist ? '0' : this.props.callSummaryStats.totalBillableAssist}</TableCell>
                                            <TableCell align="center" style={{fontFamily: 'Sofia'}}> {this.toHHMMSS(Math.round((this.props.callSummaryStats.totalBillableAssist*60)/this.props.callSummaryStats.totalAssist))}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        {/* </Paper> */}
                    </Grid>
                    {/* <Grid item md={6} xs={12}>
                            <TableContainer component={Paper}>
                                <Table className={classes.table} aria-label="simple table">
                                    <TableHead>
                                    <TableRow className={classes.tableHead}>
                                            <TableCell  align="center" colSpan={3}>Outgoing</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="center">Total Calls</TableCell>
                                            <TableCell align="center">Billable Minutes</TableCell>
                                            <TableCell align="center">Connected Call Time</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                            <TableRow>
                                                <TableCell align="center">10</TableCell>
                                                <TableCell align="center">100</TableCell>
                                                <TableCell align="center">45</TableCell>
                                            </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                    </Grid> */}
                    {/* <Grid item xs={6}>
                        <Paper className={classes.paper}>Inbound Call Details</Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <Paper className={classes.paper}>Portal Assist Details</Paper>
                    </Grid> */}
                    
                    <Grid item md={12} xs={12} style={{padding: 10}}>
                        {this.props.callVolumes && this.props.callVolumes.id && this.props.callVolumes.series &&
                                <TableChart  size="31" icon={<AccountIcons.UsageBarIcon style={{color:'black'}} />} multiY content={this.props.callVolumes} heading="Usage Insights" format="MM/DD" />
                            }
                    </Grid>

                    <Grid item md={12} xs={12} style={{padding: 10}}>

                    {this.props.contactInsights && this.props.contactInsights.id && this.props.contactInsights.series && !this.state.showMinimal && 
                            <TableChart  size="31" icon={<AccountIcons.InsightsLineIcon style={{color:'black'}} />} type="line" content={this.props.contactInsights} heading="Client Insights" format="MM/DD" />
                        }


                        {/* <Paper className={classes.paper}>
                            <div style={{ display: 'flex' }}>
                                <div className={classes.titleBar}>
                                    <AccountIcons.InsightsLineIcon />
                                    <div className={classes.title}>
                                        Client Insights
                                    </div>
                                </div>
                            </div>
                            <ReactApexChart options={this.props.contactInsights.options} series={this.props.contactInsights.series} type="line" height={350} />
                        </Paper> */}
                    </Grid>

                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        user: coreSelectors.getUser(state),
        accountId: accountSelectors.getAccountId(state),
        account: accountSelectors.getAccount(state),
        callSummaryStats: accountSelectors.getCallSummaryStats(state),
        callVolumes: accountSelectors.getCallVolumes(state),
        contactInsights: accountSelectors.getContactInsights(state),
        invoiceId: accountSelectors.getInvoiceId(state),
        phoneNumberInsights: accountSelectors.getPhoneNumberInsights(state),
    });
};

const mapDispatchToProps = {
    setAccountId: accountActions.setAccountId,
    queryAccount: accountActions.queryAccount,
    queryCallSummaryStats: accountActions.callSummaryStats,
    queryCallVolumes: accountActions.callVolumes,
    queryContactInsights: accountActions.contactInsights,
    setInvoiceId: accountActions.setInvoiceId,
    queryTasksByInvoice: accountActions.getTasksByInvoice,
    queryCombinedCallSummaryStats: accountActions.combinedCallSummaryStats,
    getPhoneNumberInsights: accountActions.getPhoneNumberInsights
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Reports));
